import { PayoutMethod } from '@/types/api/payout-account';
import { PayoutMethodIcon } from '../components/payout-method-icon';

export const PAYOUT_METHOD_OPTIONS = [
  {
    value: PayoutMethod.Swish,
    label: 'Swish',
    description: 'Snabbast att komma igång. Pengarna swishas till ditt mobilnummer.',
    icon: <PayoutMethodIcon method={PayoutMethod.Swish} />,
  },
  {
    value: PayoutMethod.BankTransfer,
    label: 'Banköverföring',
    description: 'Pengarna förs över till ditt bankkonto.',
    icon: <PayoutMethodIcon method={PayoutMethod.BankTransfer} />,
  },
];
